"use client";

import { Box, IconButton } from "@mui/material";
import useEmblaCarousel from "embla-carousel-react";
import { useCallback } from "react";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const NORMAL_PADDING = 4;

export default function Carousel({ slides, slideWidth }: { slides: React.ReactNode[]; slideWidth: number }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
  });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <Box
      className="embla"
      sx={{
        overflow: "hidden",
      }}
    >
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <IconButton
            className="embla__prev"
            onClick={scrollPrev}
            color="inherit"
          >
            <NavigateBeforeIcon />
          </IconButton>
          <IconButton
            className="embla__next"
            onClick={scrollNext}
            color="inherit"
          >
            <NavigateNextIcon />
          </IconButton>
        </Box>
      <Box
        className="embla__viewport"
        sx={(theme) => ({
          overflow: "hidden",
          [theme.breakpoints.down("sm")]: {
            overflow: "visible",
          },
        })}
        ref={emblaRef}
      >
        <Box
          className="embla__container"
          sx={{
            display: "flex",
            paddingTop: NORMAL_PADDING,
            paddingBottom: NORMAL_PADDING,
          }}
        >
          {slides.map((slide, index) => (
            <Box
              key={index}
              className="embla__slide "
              sx={{
                flex: `0 0 ${slideWidth}px`,
                minWidth: 0,
                height: "",
                paddingRight: 4,
              }}
            >
              {slide}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
